import React, { useEffect, useState } from 'react';

const DataAnalyzer = ({data}) => {

  const [analyzedData, setAnalyzedData] = useState([]);

  function parseSummaryToObject(summary) {
    // Split the summary into lines
    if (typeof summary === 'string') {
      let lines = summary && summary?.split('\n');
      return lines;
    }
    return summary;
  }

  useEffect(() => {
    setAnalyzedData(parseSummaryToObject(data?.payload));
  }, [data]);

  return (
    <div>
      {analyzedData?.length > 0 ? analyzedData?.map(data => <p>{data}</p>) : <p>{analyzedData?.error}</p>}
    </div>
  )
}

export default DataAnalyzer;